import { Trans } from 'next-i18next';
import SkipTranslationWrapper from './SkipTranslationWrapper';

type Props = {
  i18nKey: string;
  values?: { [key: string]: string | number | undefined };
};
const SkipTranslationText = ({ i18nKey, values }: Props) => {
  return (
    <Trans
      i18nKey={i18nKey}
      values={values}
      components={{
        skip: <SkipTranslationWrapper tag="span" />,
      }}
    />
  );
};

export default SkipTranslationText;
